import { render } from "./CaptureOneModalComponent.vue?vue&type=template&id=863a1a6e&ts=true"
import script from "./CaptureOneModalComponent.vue?vue&type=script&lang=ts"
export * from "./CaptureOneModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__